import React from 'react';

import HeadTitle from '../../components/HeadTitle';
import { Button, LoadingOverlay } from '../../components';
import ContainerPage from '../../components/ContainerPage';

export type AppointmentConfirmationTemplateProps = {
  loading: boolean;
  handleContinue: () => void;
  pageTitle?: string;
  buttonTitle?: string;
  goBack?: () => void;
};

export const AppointmentConfirmationTemplate: React.FC<AppointmentConfirmationTemplateProps> = ({
  handleContinue,
  loading,
  buttonTitle,
  pageTitle,
  children,
  goBack
}) => {
  return (
    <ContainerPage childrenFooter={<Button title={buttonTitle ? buttonTitle : 'Concluir'} onClick={handleContinue} />}>
      <div className="body-wrapper">
        <HeadTitle title={pageTitle ? pageTitle : 'Resumo do agendamento'} goBack={goBack} />

        {children}
      </div>

      <LoadingOverlay loading={loading} />
    </ContainerPage>
  );
};
